
import { useDispatch, useSelector } from 'react-redux'
import PageTopTitle from '../../components/shared/PageTopTitle'
import styled from 'styled-components'
import { useEffect } from 'react'
import TopMenus from '../../components/shared/TopMenus'
import SendNotificationAll from '../../components/bildirim/SendNotificationAll'
import SendNotificationSpecific from '../../components/bildirim/SendNotificationSpecific'
import { clearNotificationForm, clearPhoneNumbersForNotification, setNotificationActiveTab } from '../../features/admin4/admin4Slice'
import MobileNotificationHistory from '../../components/bildirim/MobileNotificationHistory'
import ScheduledNotificationList from '../../components/bildirim/ScheduledNotificationList'

const Container = styled.div`
    width: 100%;

    .wrapper{
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;

        .content{
          padding: 40px;
          width: auto;
          min-width: 780px;

          .sender-content{
            display: flex;
            flex-direction: column;
            align-items: center;


            .title{
              font-size: var(--font-size-md);
              font-weight: var(--font-weight-lg);
              margin: 40px 0;
              padding: 10px 30px;
              border-radius: 10px;
              background-color: ${({theme}) => theme.secondaryBgColor};
              border: 1px solid ${({theme}) => theme.mainBorderColor};
            }

            .content-container{
              width: 100%;
            }
          }
        }

        
    }
`

const menuList = [
  {
      id: 1,
      text: "Herkese Bildirim Gönder"
  },
  {
      id: 2,
      text: "Telefon Numarasına Göre Bildirim Gönder"
  },
]

const BildirimGonder = () => {

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(clearPhoneNumbersForNotification())
  },[])

  const {
    notificationActiveTab
  } = useSelector(state => state.admin4)

  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Bildirim Gönder"} position='sticky'/>

        <div className="content">
          <TopMenus activeMenuId={notificationActiveTab} setActiveMenuId={(data) => {dispatch(setNotificationActiveTab(data)); dispatch(clearNotificationForm())}} menuList={menuList} containerWidth='100%'/>

            
          <div className="sender-content">
            <h2 className="title">{notificationActiveTab === 1 ? "Herkese Bildirim Gönder" : "Telefon Numarasına Göre Bildirim Gönder"}</h2>
            <div className="content-container">

              {
                notificationActiveTab === 1 &&
                <SendNotificationAll/>
              }

              {
                notificationActiveTab === 2 &&
                <SendNotificationSpecific/>
              }
              
            </div>
          </div>
        </div>
        <ScheduledNotificationList/>

        <MobileNotificationHistory/>

    </div>
    </Container>
  )
}


export default BildirimGonder